import React from 'react'
import {Link} from 'react-router-dom'
import {inject, observer} from 'mobx-react'
import {Button} from '../../elements/Button'
import {AuthStore} from '../../stores/AuthStore'
import './LogoutFrontPageLink.scss'

interface Props {
  authStore?: AuthStore
  footerInfo: {
    text: string
    candidateId?: string
    showBackToStart?: boolean
  }
}

const LogoutFrontPageLink: React.FC<Props> = inject('authStore')(
  observer(({authStore, footerInfo}) => {
    const handleClick = () => {
      authStore?.tunnusLogout()
    }

    const {text, showBackToStart, candidateId} = footerInfo

    return (
      <div className="logout-front-page-link">
        {text && <div className="logout-front-page-link__text">{text}</div>}
        {showBackToStart && candidateId && (
          <Link to={`/ehdokas/${candidateId}`} className="logout-front-page-link__link">
            Takaisin etusivulle
          </Link>
        )}
        <Button color={'white'} onClick={handleClick}>
          Kirjaudu ulos
        </Button>
      </div>
    )
  })
)

export default LogoutFrontPageLink
